async function RemoveLoading() {
  let timer = setTimeout(() => {
    const loadingDivs = document.querySelectorAll(
      ".personalizerai__loading-skeleton"
    );

    if (!loadingDivs.length) {
      return;
    }

    console.log("Loading divs found.");
    console.log("Removing loading divs...");

    loadingDivs.forEach((div) => div.remove());
    clearTimeout(timer);

    console.log("Removed Loading divs");
  }, 5000);
}

RemoveLoading();

window.personalizerai_custom_template = {
  product: {
    "quick-add-product": {
      render(data) {
        injectGlobalStyles(document);
        const mutatedProducts = data.products
          .filter((product) => product.availableForSale)
          .map((product) => {
            const urlParams = new URLSearchParams(
              product.onlineStoreUrl.split("?")[1]
            );
            urlParams.set(
              "personalizerai_attr_token",
              product.attributionToken
            );
            const url = `${
              product.onlineStoreUrl.split("?")[0]
            }?${urlParams.toString()}`;

            return {
              ...product,
              onlineStoreUrl: url,
            };
          });

        data.products = mutatedProducts;
        new PersonalizerAIProductCard(data);
      },
    },
    "quick-add-product--small": {
      render(data) {
        injectGlobalStyles(document);

        const mutatedProducts = data.products
          .filter((product) => product.availableForSale)
          .map((product) => {
            const urlParams = new URLSearchParams(
              product.onlineStoreUrl.split("?")[1]
            );
            urlParams.set(
              "personalizerai_attr_token",
              product.attributionToken
            );
            const url = `${
              product.onlineStoreUrl.split("?")[0]
            }?${urlParams.toString()}`;

            return {
              ...product,
              onlineStoreUrl: url,
            };
          });
        data.products = mutatedProducts;
        new PersonalizeraiVerticalCard(data);
      },
    },
    "article-horizontal-grid": {
      render(data) {
        const mutatedProducts = data.products
          .filter((product) => product.availableForSale)
          .map((product) => {
            const urlParams = new URLSearchParams(
              product.onlineStoreUrl.split("?")[1]
            );
            urlParams.set(
              "personalizerai_attr_token",
              product.attributionToken
            );
            const url = `${
              product.onlineStoreUrl.split("?")[0]
            }?${urlParams.toString()}`;

            return {
              ...product,
              onlineStoreUrl: url,
            };
          });
        data.products = mutatedProducts;

        new PersonalizeraiHorizontalCard(data);
      },
    },
  },
  bundle: {
    "bundle-v2": {
      render(data) {
        injectGlobalStyles(document);
        const products = data.products;
        const mainProductHandle =
          window.location.pathname.split("/")[
            window.location.pathname.split("/").length - 1
          ];

        const finalProducts = products.filter(
          (product) => product.availableForSale
        );

        if (
          finalProducts?.length <= 1 ||
          !finalProducts.find((product) => product.handle === mainProductHandle)
        ) {
          return;
        }

        const mutatedProducts = finalProducts.map((product) => {
          const selectedVariant = product.variants.nodes.find(
            (variant) => variant.availableForSale
          );

          const onlineStoreUrl = `/products/${product.handle}?personalizerai_attr_token=${product.attributionToken}`;

          return {
            ...product,
            isMainProduct:
              decodeURI(product.handle) === decodeURI(mainProductHandle),
            isAvailable: product.availableForSale,
            variantId: selectedVariant?.id || null,
            variantValue: selectedVariant || null,
            onlineStoreUrl,
          };
        });

        data.products = mutatedProducts;

        new PersonalizerAICustomBundle(data);
      },
    },
  },
};


function injectGlobalStyles(document) {
  document.body.insertAdjacentHTML("afterend", new GlobalStyles().getStyles());
}

class GlobalStyles {
  getStyles() {
    return `
        <style>

        

            .personalizerai-product-recommendations-target {
            }

            .personalizerai-product-recommendations {
              margin: calc(var(--section-gap) * var(--fluid-1-5)) auto;
            }
            

              .personalizerai-card-fbt__product-container > div {
                display:contents !important;
              }

               .personalizerai-widget__custom__vertical-card product-recommendations .slider {
                display: block !important;
              }
              
              .personalizerai_slider__slide {
                padding:20px 10px;
              }
              
              @container pi-card-style-fbt-container (width <= 500px) {
              
                .personalizerai-card-fbt__product__content{
                  overflow:hidden;
                
                }
              
                 .personalizerai-card-fbt__product__content__title {
                    white-space: nowrap !important;
                  }
              
              }
              
              @media screen and (max-width: 750px) {
                .personalizerai-card-fbt__product__content{
                overflow:hidden;
                
                }
                
                 .personalizerai-card-fbt__product__content__title {
                    white-space: nowrap !important;
                  }
                }
                
                .personalizerai-card-fbt .personalizerai-pricing-box__price, .personalizerai-card-fbt  .personalizerai-card-fbt__product__content__title, .personalizerai-card-fbt  input[type='checkbox'], .personalizerai_product__price-container p   {
                color: #694B9E !important;
                accent-color: #694B9E;
                }

                .personalizerai-pricing-box__compare-at-price {
                  color: #D3D3D3 !important;
                }

                .personalizerai-pricing-box__discount-message {
                  color: #694B9E !important;
                }
              
              @media screen and (min-width:900px) {
                .personalizerai-card-fbt__wrapper {
                  display:flex !important;
                  flex-wrap:wrap;
                  justify-content:center;
                  align-items:center;
                  gap:16px;
                }
                
                .personalizerai-card-fbt__wrapper > div:first-child {
                  width: 100%;
                }
              
                .personalizerai-card-fbt .personalizerai-card-fbt__action { 
                  border-top:unset;
                  border-bottom:unset;
                }
              }



              .personalizerai-product-recommendations--quick-add-products {
                & .personalizerai_products_grid__item {
                  box-shadow: unset !important;
                  border-radius: unset !important;
                  padding: unset !important;
                }
              }

              @media (max-width: 600px) {
                .personalizerai-product-recommendations--quick-add-products carousel-slider ul.slider__grid {
                    --column-gap: 10px !important;
                  
                }
              }
        </style>
    
    `;
  }
}

function attributionTokenInitiator(target) {
  const attributionToken = target.getAttribute(
    "data-personalizerai-attribution-token"
  );

  if (!attributionToken) {
    return;
  }

  target.addEventListener("click", (e) => {
    document.querySelectorAll("quick-add-drawer").forEach((drawer) => {
      const productForm = drawer.querySelector("product-form");
      productForm?.setAttribute(
        "data-personalizerai-attribution-token",
        attributionToken
      );
      drawer.setAttribute(
        "data-personalizerai-attribution-token",
        attributionToken
      );
    });
  });
}

class PersonalizerAIAttributionToken {
  constructor() {
    this.quickAddDrawerMutationObserver();
  }

  quickAddDrawerMutationObserver() {
    document.querySelectorAll("quick-add-drawer").forEach((drawer) => {
      const config = { attributes: true, childList: true, subtree: true };
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          
          // product form updated
          if (
            mutation.type === "childList" &&
            mutation?.target?.nodeName?.toLowerCase() === "product-form" &&
            [...mutation.addedNodes].find(
              (node) => node.getAttribute("id") === "product-form-quickadd"
            )
          ) {
            this.addLineItem(mutation);
          }

          // modal content added after fetching from server
          if (
            mutation.type === "childList" &&
            [...mutation.addedNodes].find(
              (node) =>
                node.nodeName.toLowerCase() === "div" &&
                [...node.classList].includes("quick-add-info")
            )
          ) {

            this.updateAnchor(mutation, "open");
          }

          // anchor tags updated when variant change
          if (
            mutation.type === "attributes" &&
            mutation.target.nodeName.toLowerCase() === "a" &&
            mutation.target.getAttribute("href")
          ) {
            this.updateAnchor(mutation);
          }

          // modal either opened or closed
          if (mutation.attributeName === "aria-hidden") {

            
            // modal opened
            if (mutation?.target?.nodeName?.toLowerCase() === "quick-add-drawer" && mutation?.target?.getAttribute("aria-hidden") === "false") {
              this.addLineItem(mutation);
              this.updateAnchor(mutation, "open");
            }

            // modal closed
            if (mutation?.target?.nodeName?.toLowerCase() === "quick-add-drawer" && mutation?.target?.getAttribute("aria-hidden") === "true") {
              this.removeLineItem(mutation);
              this.resetAnchor(mutation);
            }
          }
        }
      };
      const observer = new MutationObserver(callback);
      observer.observe(drawer, config);
    });
  }

  getParentDrawer(target) {
    let current = target;

    while (current) {
      if (current.nodeName.toLowerCase() === "quick-add-drawer") {
        return current;
      }

      current = current.parentElement;
    }

    console.log("UNABLE TO FIND PARENT DRAWER");
    return null;
  }

  updateAnchor(mutation, type = "not-defined") {
    const parentDrawer = this.getParentDrawer(mutation.target);

    const attributionToken = parentDrawer?.getAttribute(
      "data-personalizerai-attribution-token"
    );

    const hrefs = this.getAnchors(mutation, type);

    if (!parentDrawer || !attributionToken || !hrefs.length) {
      return null;
    }

    hrefs.forEach((hrefElement) => {
      const href = hrefElement.getAttribute("href");

      if (!href) return null;
      const urlParams = new URLSearchParams(href.split("?")[1]);

      // check if personalizerai attr token exists then dont update it
      if (urlParams.get("personalizerai_attr_token")) {
        return null;
      }

      urlParams.set("personalizerai_attr_token", attributionToken);
      const baseUrl = href.split("?")[0];

      const url = `${baseUrl}?${urlParams.toString()}`;

      hrefElement.setAttribute("href", url);
    });
  }

  getAnchors(mutation, type = "not-defined") {
    if (type === "open") {
      return [...mutation.target.querySelectorAll("a")].filter((x) => x);
    }

    return [mutation.target];
  }

  resetAnchor(mutation) {
    mutation.target.querySelectorAll("a").forEach((anchor) => {
      const href = anchor.getAttribute("href");
      if (!href) return;

      const urlParams = new URLSearchParams(href.split("?")[1]);
      const baseUrl = href.split("?")[0];

      urlParams.delete("personalizerai_attr_token");
      anchor.setAttribute("href", `${baseUrl}?${urlParams.toString()}`);
    });
  }

  addLineItem(mutation) {
    const attributionToken = mutation.target.getAttribute(
      "data-personalizerai-attribution-token"
    );
    const form = mutation.target.querySelector("#product-form-quickadd");
    if (!form || !attributionToken) return;

    // if attribution token already exists then don't add it.
    if (form.querySelector("[name='properties[_personalizerai]'")) {
      return;
    }

    const input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", "properties[_personalizerai]");
    input.setAttribute("value", attributionToken);
    form.appendChild(input);
  }

  removeLineItem(mutation) {
    document.querySelectorAll("quick-add-drawer").forEach((drawer) => {
      drawer?.removeAttribute("data-personalizerai-attribution-token");
      const productForm = drawer?.querySelector("product-form");
      if (!productForm) return;

      productForm?.removeAttribute("data-personalizerai-attribution-token");
      const element = productForm
        .querySelector("[name='properties[_personalizerai]'")
        ?.remove();
    });
  }
}

new PersonalizerAIAttributionToken();

class PersonalizerAICustomBundle {
  constructor(data) {
    this.renderWidget(data);
  }

  renderWidget(data) {
    try {
      const html = this.Bundle(data);
      const style = this.style(data);

      data.widget.widgetNode.innerHTML = style + "\n" + html;
    } catch (err) {
      console.error(err);
      data.widget.widgetNode.innerHTML = "";
    }
  }

  style(data) {
    return "";
  }

  Bundle(data) {
    const state = this.getBundleState(data);
    const alpine = window.PersonalizerAI.library.alpine;

    alpine.data(state.id, () => {
      return { ...state.state };
    });

    const Product = this.Product.bind(this);

    return `

      <section x-cloak x-data="${state.id}" class="personalizerai-card-fbt">
        <div class="personalizerai-card-fbt__wrapper">
            <div>
                <h2
                class="personalizerai-block__heading"
                :style="{'textAlign':config.blockHeadingAlignment, 'fontWeight':config.blockHeadingBold ? '800' : ''}"
                x-text="config.heading"
              >
              </h2>
            </div>

            <div class="personalizerai-card-fbt__product-container">
              <template x-for="product,index in products" :key="product.id">
                <div style="display:flex;align-items:center;"> 
                  ${Product()}

      
                  <template x-if="!(products.length - 1 <= index)">
                        <div class="personalizerai-card-fbt__product__seperator personalizerai-bundle__product__seperator">
                        +
                        </div>
                  </template>
                  
      
                </div>
              </template>
            </div>


            <div class="personalizerai-card-fbt__action">
              <div class="personalizerai-pricing-box__price-wrapper">
                  <p class="personalizerai-pricing-box__discount-message">
                   10% off on bundle
                  </p>
                  <div
                    class="personalizerai-pricing-box personalizerai-pricing-box--big personalizerai-pricing-box--center-on-mobile"
                  >
    
                    <p class="personalizerai-pricing-box__compare-at-price" x-text="formatCurrency(totalBundlePrice().price)"></p>
    
                    <p class="personalizerai-pricing-box__price" x-text="formatCurrency(totalBundlePrice().discount)">
                    </p>
                  </div>
              </div>
              <div>
                  <button
                    :disabled="products.every((product) => !product.isAvailable) || addToCart.disabled || addToCart.loading"
                    class="button personalizerai-card-fbt__add-to-cart"
                    @click="handleAddToCart"
                    x-text="addToCart.loading ? '...' : addToCart.text"
                  >
                  </button>
                </div>
            </div>

          </div>
      </section>
  
    
    `;
  }

  Product() {
    const PricingBox = this.PricingBox.bind(this);
    const VariantSelector = this.VariantSelector.bind(this);

    return `
       <div
          :style="{'border': product.isMainProduct ? '1px solid ' + config.mainProductBorderColor : ''}"
          class="personalizerai-card-fbt__product"
          :class="{'personalizerai-card-fbt__product--hidden': !product.isAvailable, 'personalizerai-card-fbt__product--main': product.isMainProduct}"
      >
            <input
                type="checkbox"
                :checked="product.isAvailable"
                @change="product.isAvailable = $event.target.checked"
                class="personalizerai-card-fbt__product__content__checkbox personalizerai-card-fbt__product__content__checkbox--mobile"
    
            />
            <div class="personalizerai-card-fbt__product__image">
                <template x-if="product.images?.nodes?.length">
                    <a :href="product.onlineStoreUrl || ''">
                        <img 
                            loading="lazy"
                            :src="product?.variantValue?.image?.url || product.images.nodes[0].url || ''"
                            :alt="product.title"
                        />
                    </a>
                </template>
            </div>
    
    
            <div class="personalizerai-card-fbt__product__content">
                <a
                    :href="product?.onlineStoreUrl || ''"
                    class="personalizerai-card-fbt__product__content__title"
                    :title="product.title"
                    x-text="product.title"
                >
                </a>
    
                <div class="personalizerai-card-fbt__product__content__variant-selector">
                    ${VariantSelector()}
                </div>
            </div>
    
            ${PricingBox()}
            <input
            type="checkbox"
            :checked="product.isAvailable"
            @change="product.isAvailable = $event.target.checked"
            class="personalizerai-card-fbt__product__content__checkbox personalizerai-card-fbt__product__content__checkbox--desktop"
    
            />


      </div>
    `;
  }

  PricingBox() {
    return `

    <div class="personalizerai-pricing-box">
        <template x-if="product?.variantValue?.price">
            <p class="personalizerai-pricing-box__price" x-text="formatCurrency(product?.variantValue.price)"></p>
        </template>
        <template x-if="product?.variantValue?.compareAtPrice">
            <p class="personalizerai-pricing-box__compare-at-price" x-text="formatCurrency(product?.variantValue?.compareAtPrice)"></p>
        </template>
      </div>
    
    `;
  }

  VariantSelector() {
    return `
        <div class="personalizerai-select-box__wrapper">
            <select
                :value="product.variantId"
                :disabled="product.variants.nodes.length <= 1"
                @change="handleProductVariantChange(index, event)"
                class="personalizerai_product__variant-selector personalizerai-select-box personalizerai_product__variant-selector__bundle"
                :class="{'personalizerai-select-box--empty personalizerai_product__variant-selector__bundle--empty': product.variants.nodes.length <= 1}"
            >

                <template x-for="variant in product.variants.nodes" :key="variant.id">
                    <option class="personalizerai_product__variant-selector__option personalizerai-select-box__option" :value="variant.id" x-text="variant.title" :disabled="!variant.availableForSale"></option>
                </template>
            </select>

        </div>
    `;
  }

  getBundleState(data) {
    const products = data.products;
    const config = data.widget.settings;
    const meta = {
      blockId: data.widget.blockId,
      formatCurrency: window.PersonalizerAI.utils.formatCurrency,
      translations: window.PersonalizerAI.translations,
    };

    const currentDiscount = this.getDiscount();

    const { formatCurrency, translations } = meta;
    let currentTranslations = translations;
    const id = window.crypto.randomUUID();
    const stateId = `${meta.blockId}_${id}`
      .replaceAll("-", "_")
      .replaceAll(":", "_")
      .replaceAll("/", "_");

    const state = {
      products,
      config,
      shop: window?.Shopify?.shop || "",
      currentTranslations,
      addToCart: {
        loading: false,
        text: currentTranslations.addItemsToCart,
        disabled: false,
      },
      totalBundlePrice() {
        const productArr = this.products;
        const availableProducts = this.products.filter(
          (product) => product.isAvailable
        );
        const compareAtPrices = this.products.filter(
          (product) =>
            product.isAvailable && product.variantValue?.compareAtPrice
        );

        let compareAtTotal = { amount: 0 };

        if (availableProducts.length === compareAtPrices.length) {
          compareAtTotal = compareAtPrices.reduce(
            (acc, currentValue) => {
              return {
                amount:
                  acc.amount +
                  parseFloat(currentValue.variantValue.compareAtPrice.amount),
                currencyCode:
                  currentValue.variantValue.compareAtPrice.currencyCode,
              };
            },
            { amount: 0, currencyCode: "USD" }
          );
        }

        let total = productArr
          .filter((product) => product.isAvailable)
          .reduce(
            (acc, currentValue) => {
              return {
                amount:
                  acc.amount +
                  parseFloat(currentValue.variantValue.price.amount),
                currencyCode: currentValue.variantValue.price.currencyCode,
              };
            },
            { amount: 0, currencyCode: "USD" }
          );

        const final = {
          price: total,
          discount: {
            amount: total.amount - total.amount * 0.1,
            currencyCode: total.currencyCode,
          },
          compareAtPrice:
            compareAtTotal && total.amount < compareAtTotal.amount
              ? compareAtTotal
              : null,
        };
        if (compareAtTotal.amount === 0) {
          delete final.compareAtPrice;
        }

        return final;
      },
      handleAvailabilityChange(index, event) {
        const target = event?.target;
        if (this.products[index] && target) {
          this.products[index].isAvailable = target.checked;
        }
      },
      handleProductVariantChange(index, event) {
        const target = event?.target;
        if (this.products[index] && target) {
          const variantId = target.value;
          const variant = this.products[index].variants.nodes.find(
            (variant) => variant.id === variantId
          );

          if (!variant) return;
          this.products[index].variantValue = variant;
          this.products[index].variantId = variant.id;
        }
      },
      discount: currentDiscount,
      async handleAddToCart() {
        try {
          this.addToCart.loading = true;

          const items = {
            items: this.products
              .filter((product) => product.isAvailable)
              .map((product) => ({
                id: parseInt(
                  product.variantValue.id.split(
                    "gid://shopify/ProductVariant/"
                  )[1]
                ),
                quantity: 1,
                properties: {
                  _personalizerai:
                    product.attributionToken || `model_id--${config.model}`,
                  _personalizerai_bundle_type: product.isMainProduct
                    ? "PARENT"
                    : "CHILD",
                },
              })),
          };

          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(items),
            }
          );

          if (response?.status && response?.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = this.currentTranslations.unableToAdd;
            this.addToCart.disabled = true;

            setTimeout(() => {
              this.addToCart.text = this.currentTranslations.addItemsToCart;
              this.addToCart.disabled = false;
            }, 2000);
            return;
          }

          this.addToCart.loading = false;
          this.addToCart.text = this.currentTranslations.added;
          this.addToCart.disabled = true;
          setTimeout(() => {
            this.addToCart.text = this.currentTranslations.addItemsToCart;
            this.addToCart.disabled = false;

            window?.Vanga?.open?.(); // opening mini cart
          }, 2000);
          return;
        } catch (err) {
          if (err?.status && err.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = this.currentTranslations.unableToAdd;
            this.addToCart.disabled = true;
          }
        } finally {
          this.addToCart.loading = false;
        }
      },
      formatCurrency,
    };

    return {
      id: stateId,
      state,
    };
  }

  getDiscount() {
    return {
      percentage: 0.1,
    };
  }
}

class PersonalizerAIProductCard {
  constructor(data, meta) {
    this.data = data;
    this.widget = data.widget.widgetNode;
    this.blockId = data.widget.blockId;
    this.products = this.data.products;

    this.Slider();
  }

  Slider() {
    try {
      const data = this.data;
      const alpine = window.PersonalizerAI.library.alpine;

      const id = window.crypto.randomUUID();
      const stateId = `personalizerai_product_recommendations_${id.replaceAll(
        "-",
        "_"
      )}`;

      alpine.data(stateId, () => {
        return {
          shop: window?.Shopify?.shop || "",
          config: this.data.widget.settings,
          blockId: this.data.widget.blockId,
        };
      });

      const Products = this.Products.bind(this);

      const html = `
    <div data-cc-animate x-cloak x-data="${stateId}" class="personalizerai-product-recommendations personalizerai-product-recommendations--quick-add-products">

          <div class="container mb-heading">
            <h2 class="h4 section__heading text-start" x-text="config.heading"></h2>
          </div>
         

        <carousel-slider class="carousel block" data-personalizerai>
              <div class="container relative" data-overlayscrollbars="host">

                <div class="os-size-observer"><div class="os-size-observer-listener ltr"></div></div>
                
        
                <div 
                  class="slider is-grabbable"
                  data-overlayscrollbars-viewport="scrollbarHidden"
                  :id="window.crypto.randomUUID()"
                  >
                    <div class="container products-grid-container">
                      <ul class="slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile sm:auto-cols-3 xl:auto-cols-4 gap-x-theme gap-y-8 small__grid" role="list">
                          ${Products({
                            products: data.products,
                            config: data.widget.settings,
                            meta: {
                              shop: window.Shopify.shop,
                              blockId: data.widget.blockId,
                              formatCurrency:
                                window.PersonalizerAI.utils.formatCurrency,
                              translations: window.PersonalizerAI.translations,
                              attributionToken: data.attributionToken,
                            },
                            alpine,
                          })}
                        </ul>
                      </div>
                    </div>




                    

                    
                  </div>
            </carousel-slider>
    </div>
    `;

      data.widget.widgetNode.innerHTML = html;
    } catch (err) {
      console.error(err);
      this.data.widget.widgetNode.innerHTML = "";
    }
  }

  Products({ products, config, meta, alpine }) {
    const ProductCard = this.ProductCard.bind(this);
    return products
      .map((product) => {
        return `
        <li class="slider__item">
          ${ProductCard({
            product,
            config,
            meta,
            alpine,
          })}
        </li>
        `;
      })
      .join("");
  }

  ProductCard({ product, config, meta, alpine }) {
    const productState = this.getProductCardState({
      product,
      config,
      meta,
    });
    alpine.data(productState.id, () => {
      return {
        ...productState.state,
      };
    });

    return `

     <div 
       x-data="${productState.id}" 
      >





       <product-card  class="card card--product h-full card--product-contained card--no-lines relative flex">



              <div class="card__media has-hover-image relative">
                  <a :href="product.onlineStoreUrl" :aria-label="product.title" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">
                    <template x-for="(image,index) in product?.images?.nodes">
                      <img loading="lazy" class="img-fit" :class="{'card__main-image': index === 0, 'card__hover-image': product?.images?.nodes?.length - 1=== index}"  :src="image.url" :alt="image?.altText">
                    </template>
                  </a>
                </div>











       
       
               <div class="card__info-container flex flex-col flex-auto relative">
                      <div class="card__info w-full">
                          <div class="card__info-inner inline-block w-full">
                            <p class="card__title font-bold mt-1 mb-0">
                              <a :href="product.onlineStoreUrl" class="card-link text-current js-prod-link" x-text="product.title"></a>
                            </p>
                          <div>
  
                            <div class="rating inline-block align-middle" role="img" :aria-label="(product?.rating?.value || 0) + ' out of 5.0 stars'">
                              <span class="rating__stars" aria-hidden="true"  :style="{'--rating': product?.rating?.value || 0, '--rating-max': 5, 'visibility': !product?.rating?.value ? 'hidden' : 'unset' }">★★★★★</span>
                            </div>
  
  
                            <div class="rating__count inline-block align-middle text-sm" x-text="'(' + (product?.rating_count?.value || 0) + ')'"
                              :style="{'visibility': !product?.rating?.value ? 'hidden' : 'unset'}"
                            ></div>
  
                        </div>
  
                      
                        <div class="price price--top">
                          <div class="price__default">
                              <template x-if="product.variants.nodes.length > 1">
                                <span class="price__from">From</span>
                              </template>
                              <strong class="price__current" x-text="formatCurrency(product.priceRange.minVariantPrice)"></strong>
                              <s class="price__was"></s>
                          </div>
                        </div>

                  </div>

                      
                </div>

                <div
                    class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below"
                    >

                      <template x-if="!product.availableForSale">
                          <button disabled  class="btn btn--primary w-full" data-add-to-cart-text="<svg width=&quot;24&quot; height=&quot;24&quot; viewBox=&quot;0 0 24 24&quot; class=&quot;icon icon--cart&quot; aria-hidden=&quot;true&quot; focusable=&quot;false&quot; role=&quot;presentation&quot;><path fill=&quot;currentColor&quot; d=&quot;M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z&quot;/></svg>Add to cart" name="add" aria-haspopup="dialog">
                            <span class="quick-add-btn-icon">
                              <span class="visually-hidden">
                                <svg width="24" height="24" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation">
                                  <path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z">
                                  </path>
                                </svg>
                                Out of stock
                              </span>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon">
                                <path d="M12.12 20.44H5.6V9.56h12.8v3.73c.06.4.4.69.8.7.44 0 .8-.35.8-.8v-4.5a.792.792 0 0 0-.8-.69H17V6.5C16.9 4 14.7 2 12 2S7 4.09 7 6.67V8H4.71c-.4.04-.71.37-.71.78v12.53a.8.8 0 0 0 .8.69h7.43c.38-.06.67-.39.67-.78 0-.43-.35-.78-.78-.78ZM8.66 6.67c0-1.72 1.49-3.11 3.33-3.11s3.33 1.39 3.33 3.11V8H8.65V6.67Z">
                                </path>
                                <path d="M20 17.25h-2.4v-2.5a.817.817 0 0 0-.8-.7c-.44 0-.8.36-.8.8v2.4h-2.5c-.4.06-.7.4-.7.8 0 .44.36.8.8.8H16v2.5c.06.4.4.7.8.7.44 0 .8-.36.8-.8v-2.4h2.5c.4-.06.69-.4.7-.8 0-.44-.35-.8-.8-.8Z">
                                </path>
                              </svg>
                            </span>
                            <span class="quick-add-btn-text">
                              <svg width="16" height="16" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation">
                                <path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z">
                                </path>
                              </svg>
                              Out of stock
                            </span>
                          </button>
                      </template>


                      <template x-if="product.variants.nodes.length === 1 && product.availableForSale">
                          <product-form>
                            <div class="alert mb-8 bg-error-bg text-error-text js-form-error text-start" role="alert" hidden></div>
                            <form method="post" action="/cart/add" accept-charset="UTF-8" class="js-product-form" enctype="multipart/form-data" novalidate="novalidate">
                              <input type="hidden" name="form_type" value="product">
                              <input type="hidden" name="utf8" value="✓">
                              <input type="hidden" name="id" :value="product.variants.nodes[0]?.id.split('gid://shopify/ProductVariant/')[1]">
                              <button  class="btn btn--primary w-full" data-add-to-cart-text="Add to cart" name="add" aria-haspopup="dialog">
                                  <span class="quick-add-btn-icon">
                                    <span class="visually-hidden">
                                      <svg width="24" height="24" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation">
                                        <path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z">
                                        </path>
                                      </svg>
                                      <span >
                                        Add to cart
                                      </span>
                                    </span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon">
                                      <path d="M12.12 20.44H5.6V9.56h12.8v3.73c.06.4.4.69.8.7.44 0 .8-.35.8-.8v-4.5a.792.792 0 0 0-.8-.69H17V6.5C16.9 4 14.7 2 12 2S7 4.09 7 6.67V8H4.71c-.4.04-.71.37-.71.78v12.53a.8.8 0 0 0 .8.69h7.43c.38-.06.67-.39.67-.78 0-.43-.35-.78-.78-.78ZM8.66 6.67c0-1.72 1.49-3.11 3.33-3.11s3.33 1.39 3.33 3.11V8H8.65V6.67Z">
                                      </path>
                                      <path d="M20 17.25h-2.4v-2.5a.817.817 0 0 0-.8-.7c-.44 0-.8.36-.8.8v2.4h-2.5c-.4.06-.7.4-.7.8 0 .44.36.8.8.8H16v2.5c.06.4.4.7.8.7.44 0 .8-.36.8-.8v-2.4h2.5c.4-.06.69-.4.7-.8 0-.44-.35-.8-.8-.8Z">
                                      </path>
                                    </svg>
                                  </span>
                                  <span class="quick-add-btn-text">
                                    <svg width="16" height="16" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation">
                                      <path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z">
                                      </path>
                                    </svg>
                                    <span >
                                        Add to cart
                                      </span>
                                  </span>
                              </button>


                              <input type="hidden" name="product-id" :value="product?.id.split('gid://shopify/Product/')[1]">
                              <input type="hidden" name="properties[_personalizerai]" :value="product.attributionToken" />
                            </form>
                          
                          </product-form>
                          
                      </template>

                      <template x-if="product.variants.nodes.length > 1 && product.availableForSale">
                          <div class="no-js-hidden">
                            <button
                            x-effect="attributionTokenInitiator($el);"
                              data-personalizerai-attribution-token="${meta.attributionToken}"
    
                              type="button"
                              class="btn btn--primary w-full js-quick-add"
                              aria-haspopup="dialog"
                              :data-product-url="'/products/' + product.handle"
                              data-product-default-variant="false"
                              data-quick-add-listener-added="true"
                            >
                              <span class="quick-add-btn-icon block pointer-events-none">
                                <span class="visually-hidden">Choose Options</span>
                              </span>
                              <span class="quick-add-btn-text block pointer-events-none">
                                Choose Options</span
                              >
                            </button>
                            <a
                              :href="'/products/' + product.handle"
                              class="btn btn--secondary quick-add-view-btn"
                              >View details</a
                            >
                          </div>
                      </template>
                      
                </div>
        </div>
    </product-card>
    </div>


      
    
    `;
  }

  getProductCardState({ product, config, meta }) {
    let currentTranslations = meta.translations;
    const initialVariant = this._getInitialVariant(product);
    const stateId = `${meta.blockId}_${product.id}`
      .replaceAll("-", "_")
      .replaceAll(":", "_")
      .replaceAll("/", "_");

    const state = {
      shop: meta.shop || "",
      product,
      selectedVariantId: initialVariant?.id || null,
      config,
      selectedVariant() {
        let id = this.selectedVariantId;
        if (!id) return null;

        const variant = this.product.variants.nodes.find(
          (variant) => variant.id === id
        );
        if (!variant) return null;

        return variant;
      },

      getProductImageUrl() {
        let imageUrl = "";
        if (this.config.imageType === "featured") {
          imageUrl = this.product?.images?.nodes?.length
            ? this.product.images.nodes[0].url
            : "";
        } else if (this.config.imageType === "variant") {
          // @ts-ignore
          imageUrl = this.selectedVariant()?.image?.url || "";
        } else if (this.config.imageType === "featured-and-variant") {
          // @ts-ignore
          imageUrl = this.selectedVariant()?.image?.url || "";
        }

        // add placeholder image url
        return imageUrl ? imageUrl : "";
      },
      productPricing() {
        let priceRange = "";
        let compareAtPriceRange = "";

        if (this?.selectedVariant()?.price) {
          priceRange = meta.formatCurrency(this?.selectedVariant().price);
          compareAtPriceRange = this.selectedVariant().compareAtPrice
            ? meta.formatCurrency(this.selectedVariant()?.compareAtPrice)
            : "";
        } else {
          const minPrice = product.priceRange.minVariantPrice.amount;
          const maxPrice = product.priceRange.maxVariantPrice.amount;
          const minCompareAtPrice =
            product.compareAtPriceRange.minVariantPrice.amount;
          const maxCompareAtPrice =
            product.compareAtPriceRange.maxVariantPrice.amount;
          // TODO: fix the logic to show both price and compare at price when available
          if (!maxCompareAtPrice) {
            if (maxPrice === minPrice) {
              priceRange = meta.formatCurrency(
                product.priceRange.maxVariantPrice
              );
            } else {
              priceRange = `${meta.formatCurrency(
                product.priceRange.minVariantPrice
              )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;
            }
          } else if (maxCompareAtPrice > maxPrice) {
            if (
              maxPrice === minPrice ||
              maxCompareAtPrice === minCompareAtPrice
            ) {
              priceRange = meta.formatCurrency(
                product.priceRange.minVariantPrice
              );
              compareAtPriceRange = meta.formatCurrency(
                product.compareAtPriceRange.minVariantPrice
              );
            } else {
              priceRange = `${meta.formatCurrency(
                product.priceRange.minVariantPrice
              )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;

              compareAtPriceRange = `${meta.formatCurrency(
                product.compareAtPriceRange.minVariantPrice
              )}-${meta.formatCurrency(
                product.compareAtPriceRange.maxVariantPrice
              )}`;
            }
          } else {
            priceRange = `${meta.formatCurrency(
              product.priceRange.minVariantPrice
            )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;
          }
        }

        return { priceRange, compareAtPriceRange };
      },

      currentTranslations,
      addToCart: {
        loading: false,
        text: currentTranslations.addToCart,
        disabled: false,
      },
      async onAddToCart() {
        try {
          this.addToCart.loading = true;

          if (!this.selectedVariant()) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.unableToAdd;
            this.addToCart.disabled = true;
            setTimeout(() => {
              this.addToCart.text = currentTranslations.addToCart;
              this.addToCart.disabled = false;
            }, 2000);
            return;
          }

          const items = {
            items: [
              {
                id: this.selectedVariant().id.split(
                  "gid://shopify/ProductVariant/"
                )[1],
                quantity: 1,
                properties: {
                  _personalizerai:
                    this.product?.attributionToken ||
                    `model_id--${this.config.model}`,
                },
              },
            ],
          };

          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(items),
            }
          );

          if (response?.status && response?.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.outOfStock;
            this.addToCart.disabled = true;

            setTimeout(() => {
              this.addToCart.text = currentTranslations.outOfStock;
              this.addToCart.disabled = false;
            }, 2000);
            return;
          }

          this.addToCart.loading = false;
          this.addToCart.text = currentTranslations.added;
          this.addToCart.disabled = true;
          setTimeout(() => {
            this.addToCart.text = currentTranslations.addToCart;
            this.addToCart.disabled = false;
          }, 2000);
          return;
        } catch (err) {
          if (err?.status && err.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.outOfStock;
            this.addToCart.disabled = true;
          }
        } finally {
          this.addToCart.loading = false;
        }
      },
      formatCurrency: meta.formatCurrency,
    };

    return {
      id: stateId,
      state,
    };
  }

  _getInitialVariant(product) {
    const variantsAvailableForSale = product.variants.nodes.filter(
      (variant) => variant.availableForSale
    );

    if (variantsAvailableForSale.length <= 1) {
      return variantsAvailableForSale?.[0] || null;
    }

    const leastPriceVariant = variantsAvailableForSale.reduce(
      (acc, current) => {
        if (parseFloat(acc.price.amount) > parseFloat(current.price.amount)) {
          return current;
        } else {
          return acc;
        }
      },
      variantsAvailableForSale[0]
    );

    return leastPriceVariant;
  }
}

class PersonalizeraiVerticalCard {
  constructor(data) {
    this.data = data;
    this.widget = data.widget.widgetNode;
    this.blockId = data.widget.blockId;
    this.products = this.data.products;

    this.Slider();
  }

  getStyles() {
    return `

    <style>
    
    </style>
    
    `;
  }

  Slider() {
    try {
      const data = this.data;
      const alpine = window.PersonalizerAI.library.alpine;

      const id = window.crypto.randomUUID();
      const stateId = `personalizerai_product_recommendations_${id.replaceAll(
        "-",
        "_"
      )}`;

      alpine.data(stateId, () => {
        return {
          shop: window?.Shopify?.shop || "",
          config: this.data.widget.settings,
          blockId: this.data.widget.blockId,
        };
      });

      const Products = this.Products.bind(this);
      const sliderId = window.crypto.randomUUID();

      const html = `
    
    <div data-cc-animate x-cloak x-data="${stateId}" style="margin:unset;" class="personalizerai-product-recommendations personalizerai-product-recommendations--quick-add-products personalizerai-widget__custom__vertical-card">
         



      <product-recommendations class="block cart-recommendations">
        <carousel-slider class="carousel block">


                <div class="mb-2 flex items-center justify-between" >
                    <h2 class="flex-auto mb-0 h6 max-w-full" x-text="config.heading"></h2>
                    <div class="slider-nav slide-nav--inline flex no-js-hidden">
                      <button aria-controls="${sliderId}" type="button" class="slider-nav__btn tap-target btn has-ltr-icon" name="prev"  disabled="">
                        <span class="visually-hidden">Previous</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon">
                          <path d="m6.797 11.625 8.03-8.03 1.06 1.06-6.97 6.97 6.97 6.97-1.06 1.06z">
                          </path>
                        </svg>
                      </button>
                      <button aria-controls="${sliderId}" type="button" class="slider-nav__btn slider-nav__btn--offset tap-target btn has-ltr-icon" name="next">
                        <span class="visually-hidden">Next</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon">
                          <path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none">
                          </path>
                        </svg>
                      </button>
                    </div>
                </div>


                <div class="relative">
                  <div class="slider slider--no-scrollbar is-grabbable" id="${sliderId}">
                    <ul class="slider__grid grid grid-flow-col auto-cols-1 gap-x-theme small__grid" role="list">

                        ${Products({
                          products: data.products,
                          config: data.widget.settings,
                          meta: {
                            shop: window.Shopify.shop,
                            blockId: data.widget.blockId,
                            formatCurrency:
                              window.PersonalizerAI.utils.formatCurrency,
                            translations: window.PersonalizerAI.translations,
                            attributionToken: data.attributionToken,
                          },
                          alpine,
                        })}
                    </ul>
                  </div>
                </div>

            
      
            </carousel-slider>
          </product-recommendations>
      </div>
    `;

      data.widget.widgetNode.innerHTML = html;
    } catch (err) {
      console.error(err);
      this.data.widget.widgetNode.innerHTML = "";
    }
  }

  Products({ products, config, meta, alpine }) {
    const ProductCard = this.ProductCard.bind(this);
    return products
      .map((product) => {
        return `
        <li class="slider__item">
          ${ProductCard({
            product,
            config,
            meta,
            alpine,
          })}
        </li>
        `;
      })
      .join("");
  }

  ProductCard({ product, config, meta, alpine }) {
    const productState = this.getProductCardState({
      product,
      config,
      meta,
    });
    alpine.data(productState.id, () => {
      return {
        ...productState.state,
      };
    });

    return `

     <div 
       x-data="${productState.id}" 
      >

        <div class="card card--row card--related  relative flex" >
            <div class="card__media">
              <div class="media relative" style="padding-top: 100.0%;">
                  <img loading="lazy"  class="img-fit" loading="lazy"  :src="product?.images?.nodes?.[0]?.url" :alt="product?.images?.nodes?.[0]?.altText">
              </div>
            </div>

            <div class="card__info">
              <p class="h6 regular-text mt-2 mb-1">
                <a :href="product.onlineStoreUrl" class="card-link text-current" x-text="product.title"></a>
              </p>

              <div class="price">
                          <div class="price__default">
                              <template x-if="product.variants.nodes.length > 1">
                                <span class="price__from">From</span>
                              </template>
                              <strong class="price__current" x-text="formatCurrency(product.priceRange.minVariantPrice)"></strong>
                              <s class="price__was"></s>
                          </div>
                </div>


                <template x-if="product.variants.nodes.length === 1 && product.availableForSale">
                          <product-form>
                            <div class="alert mb-8 bg-error-bg text-error-text js-form-error text-start" role="alert" hidden></div>
                            <form method="post" action="/cart/add" accept-charset="UTF-8" class="js-product-form" enctype="multipart/form-data" novalidate="novalidate">
                              <input type="hidden" name="form_type" value="product">
                              <input type="hidden" name="utf8" value="✓">
                              <input type="hidden" name="id" :value="product.variants.nodes[0]?.id.split('gid://shopify/ProductVariant/')[1]">
                              <button  class="btn btn--secondary btn--sm" data-add-to-cart-text="Add to cart" name="add" aria-haspopup="dialog">
                                  Add to cart
                              </button>


                              <input type="hidden" name="product-id" :value="product?.id.split('gid://shopify/Product/')[1]">
                              <input type="hidden" name="properties[_personalizerai]" :value="product.attributionToken" />
                            </form>
                          
                          </product-form>
                          
                </template>


                <template x-if="product.variants.nodes.length > 1 && product.availableForSale">
                      <div class="no-js-hidden">
                            <button
                              x-effect="attributionTokenInitiator($el);"
                              data-personalizerai-attribution-token="${meta.attributionToken}"
    
                              type="button"
                              class="btn btn--secondary btn--sm js-quick-add no-js-hidden"
                              aria-haspopup="dialog"
                              :data-product-url="'/products/' + product.handle"
                              data-product-default-variant="false"
                              data-quick-add-listener-added="true"
                            >
                              <span class="quick-add-btn-icon block pointer-events-none">
                                <span class="visually-hidden">Choose Options</span>
                              </span>
                              <span class="quick-add-btn-text block pointer-events-none">
                                Choose Options</span
                              >
                            </button>
                            <a
                              :href="'/products/' + product.handle"
                              class="btn btn--secondary quick-add-view-btn"
                              >View details</a
                            >
                      </div>
                  </template>

                
            
            </div>

            
        </div>


    </div>


      
    
    `;
  }

  getProductCardState({ product, config, meta }) {
    let currentTranslations = meta.translations;
    const initialVariant = this._getInitialVariant(product);
    const stateId = `${meta.blockId}_${product.id}`
      .replaceAll("-", "_")
      .replaceAll(":", "_")
      .replaceAll("/", "_");

    const state = {
      shop: meta.shop || "",
      product,
      selectedVariantId: initialVariant?.id || null,
      config,
      selectedVariant() {
        let id = this.selectedVariantId;
        if (!id) return null;

        const variant = this.product.variants.nodes.find(
          (variant) => variant.id === id
        );
        if (!variant) return null;

        return variant;
      },

      getProductImageUrl() {
        let imageUrl = "";
        if (this.config.imageType === "featured") {
          imageUrl = this.product?.images?.nodes?.length
            ? this.product.images.nodes[0].url
            : "";
        } else if (this.config.imageType === "variant") {
          // @ts-ignore
          imageUrl = this.selectedVariant()?.image?.url || "";
        } else if (this.config.imageType === "featured-and-variant") {
          // @ts-ignore
          imageUrl = this.selectedVariant()?.image?.url || "";
        }

        // add placeholder image url
        return imageUrl ? imageUrl : "";
      },
      productPricing() {
        let priceRange = "";
        let compareAtPriceRange = "";

        if (this?.selectedVariant()?.price) {
          priceRange = meta.formatCurrency(this?.selectedVariant().price);
          compareAtPriceRange = this.selectedVariant().compareAtPrice
            ? meta.formatCurrency(this.selectedVariant()?.compareAtPrice)
            : "";
        } else {
          const minPrice = product.priceRange.minVariantPrice.amount;
          const maxPrice = product.priceRange.maxVariantPrice.amount;
          const minCompareAtPrice =
            product.compareAtPriceRange.minVariantPrice.amount;
          const maxCompareAtPrice =
            product.compareAtPriceRange.maxVariantPrice.amount;
          // TODO: fix the logic to show both price and compare at price when available
          if (!maxCompareAtPrice) {
            if (maxPrice === minPrice) {
              priceRange = meta.formatCurrency(
                product.priceRange.maxVariantPrice
              );
            } else {
              priceRange = `${meta.formatCurrency(
                product.priceRange.minVariantPrice
              )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;
            }
          } else if (maxCompareAtPrice > maxPrice) {
            if (
              maxPrice === minPrice ||
              maxCompareAtPrice === minCompareAtPrice
            ) {
              priceRange = meta.formatCurrency(
                product.priceRange.minVariantPrice
              );
              compareAtPriceRange = meta.formatCurrency(
                product.compareAtPriceRange.minVariantPrice
              );
            } else {
              priceRange = `${meta.formatCurrency(
                product.priceRange.minVariantPrice
              )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;

              compareAtPriceRange = `${meta.formatCurrency(
                product.compareAtPriceRange.minVariantPrice
              )}-${meta.formatCurrency(
                product.compareAtPriceRange.maxVariantPrice
              )}`;
            }
          } else {
            priceRange = `${meta.formatCurrency(
              product.priceRange.minVariantPrice
            )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;
          }
        }

        return { priceRange, compareAtPriceRange };
      },

      currentTranslations,
      addToCart: {
        loading: false,
        text: currentTranslations.addToCart,
        disabled: false,
      },
      async onAddToCart() {
        try {
          this.addToCart.loading = true;

          if (!this.selectedVariant()) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.unableToAdd;
            this.addToCart.disabled = true;
            setTimeout(() => {
              this.addToCart.text = currentTranslations.addToCart;
              this.addToCart.disabled = false;
            }, 2000);
            return;
          }

          const items = {
            items: [
              {
                id: this.selectedVariant().id.split(
                  "gid://shopify/ProductVariant/"
                )[1],
                quantity: 1,
                properties: {
                  _personalizerai:
                    this.product?.attributionToken ||
                    `model_id--${this.config.model}`,
                },
              },
            ],
          };

          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(items),
            }
          );

          if (response?.status && response?.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.outOfStock;
            this.addToCart.disabled = true;

            setTimeout(() => {
              this.addToCart.text = currentTranslations.outOfStock;
              this.addToCart.disabled = false;
            }, 2000);
            return;
          }

          this.addToCart.loading = false;
          this.addToCart.text = currentTranslations.added;
          this.addToCart.disabled = true;
          setTimeout(() => {
            this.addToCart.text = currentTranslations.addToCart;
            this.addToCart.disabled = false;
          }, 2000);
          return;
        } catch (err) {
          if (err?.status && err.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.outOfStock;
            this.addToCart.disabled = true;
          }
        } finally {
          this.addToCart.loading = false;
        }
      },
      formatCurrency: meta.formatCurrency,
    };

    return {
      id: stateId,
      state,
    };
  }

  _getInitialVariant(product) {
    const variantsAvailableForSale = product.variants.nodes.filter(
      (variant) => variant.availableForSale
    );

    if (variantsAvailableForSale.length <= 1) {
      return variantsAvailableForSale?.[0] || null;
    }

    const leastPriceVariant = variantsAvailableForSale.reduce(
      (acc, current) => {
        if (parseFloat(acc.price.amount) > parseFloat(current.price.amount)) {
          return current;
        } else {
          return acc;
        }
      },
      variantsAvailableForSale[0]
    );

    return leastPriceVariant;
  }
}

class PersonalizeraiHorizontalCard {
  constructor(data) {
    this.renderWidget(data);
    
  }

  renderWidget(data) {

    const ProductCard = this.ProductCard.bind(this);
    const productsHTML = data.products.map((product) =>
      ProductCard({
        product,
        config: {
          heading: "Related Products",
        },
        meta: {
          shop: window.Shopify.shop,
          blockId: data.widget.blockId,
          formatCurrency: window.PersonalizerAI.utils.formatCurrency,
          translations: window.PersonalizerAI.translations,
          attributionToken: data.attributionToken,
        },
        alpine: window.PersonalizerAI.library.alpine,
      })
    );

    data.widget.widgetNode.innerHTML = `
    <style>
      [x-cloak] {
        display: none !important;
      }
    </style>
      <div  class="article__title rte mb-6 md:mb-8 last:mb-0 reading-width mx-auto">
          <h2 class="mb-0" :style="{fontSize: '30px'}">Related Products</h2>            
      </div>
      <div >
        ${productsHTML.join("")}
      </div>
    `;

    
    
  }

  ProductCard({ product, config, meta, alpine }) {
    const productState = this.getProductCardState({
      product,
      config,
      meta,
    });
    alpine.data(productState.id, () => {
      return {
        ...productState.state,
      };
    });

    return `

     <li 
       style="margin-bottom: 16px;"
       x-data="${productState.id}" 
       x-cloak
      >





       <product-card data-cc-animate  class="card card--product card--product-contained card--no-lines relative flex">



              <div class="card__media has-hover-image relative">
                  <a :href="product.onlineStoreUrl" :aria-label="product.title" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">
                    <template x-for="(image,index) in product?.images?.nodes">
                      <img loading="lazy" class="img-fit" :class="{'card__main-image': index === 0, 'card__hover-image': product?.images?.nodes?.length - 1=== index}"  :src="image.url" :alt="image?.altText">
                    </template>
                  </a>
                </div>











       
       
               <div class="card__info-container flex flex-col flex-auto relative">
                      <div class="card__info w-full">
                          <div class="card__info-inner inline-block w-full">
                            <h3 class="card__title font-bold mt-1 mb-0" :style="{fontSize:'calc(var(--body-font-size) * .1rem)'}">

                                <a :href="product.onlineStoreUrl" class="card-link text-current js-prod-link" x-text="product.title"></a>

                            </h3>
                          <div>
  
                            <div class="rating inline-block align-middle" role="img" :aria-label="(product?.rating?.value || 0) + ' out of 5.0 stars'">
                              <span class="rating__stars" aria-hidden="true"  :style="{'--rating': product?.rating?.value || 0, '--rating-max': 5, 'visibility': !product?.rating?.value ? 'hidden' : 'unset' }">★★★★★</span>
                            </div>
  
  
                            <div class="rating__count inline-block align-middle text-sm" x-text="'(' + (product?.rating_count?.value || 0) + ')'"
                              :style="{'visibility': !product?.rating?.value ? 'hidden' : 'unset'}"
                            ></div>
  
                        </div>
  
                      
                        <div class="price price--top">
                          <div class="price__default">
                              <template x-if="product.variants.nodes.length > 1">
                                <span class="price__from">From</span>
                              </template>
                              <strong class="price__current" x-text="formatCurrency(product.priceRange.minVariantPrice)"></strong>
                              <s class="price__was"></s>
                          </div>
                        </div>

                  </div>

                      
                </div>

                <div
                    class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below"
                    >

                      <template x-if="!product.availableForSale">
                          <button disabled  class="btn btn--primary w-full" data-add-to-cart-text="<svg width=&quot;24&quot; height=&quot;24&quot; viewBox=&quot;0 0 24 24&quot; class=&quot;icon icon--cart&quot; aria-hidden=&quot;true&quot; focusable=&quot;false&quot; role=&quot;presentation&quot;><path fill=&quot;currentColor&quot; d=&quot;M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z&quot;/></svg>Add to cart" name="add" aria-haspopup="dialog">
                            <span class="quick-add-btn-icon">
                              <span class="visually-hidden">
                                <svg width="24" height="24" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation">
                                  <path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z">
                                  </path>
                                </svg>
                                Out of stock
                              </span>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon">
                                <path d="M12.12 20.44H5.6V9.56h12.8v3.73c.06.4.4.69.8.7.44 0 .8-.35.8-.8v-4.5a.792.792 0 0 0-.8-.69H17V6.5C16.9 4 14.7 2 12 2S7 4.09 7 6.67V8H4.71c-.4.04-.71.37-.71.78v12.53a.8.8 0 0 0 .8.69h7.43c.38-.06.67-.39.67-.78 0-.43-.35-.78-.78-.78ZM8.66 6.67c0-1.72 1.49-3.11 3.33-3.11s3.33 1.39 3.33 3.11V8H8.65V6.67Z">
                                </path>
                                <path d="M20 17.25h-2.4v-2.5a.817.817 0 0 0-.8-.7c-.44 0-.8.36-.8.8v2.4h-2.5c-.4.06-.7.4-.7.8 0 .44.36.8.8.8H16v2.5c.06.4.4.7.8.7.44 0 .8-.36.8-.8v-2.4h2.5c.4-.06.69-.4.7-.8 0-.44-.35-.8-.8-.8Z">
                                </path>
                              </svg>
                            </span>
                            <span class="quick-add-btn-text">
                              <svg width="16" height="16" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation">
                                <path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z">
                                </path>
                              </svg>
                              Out of stock
                            </span>
                          </button>
                      </template>


                      <template x-if="product.variants.nodes.length === 1 && product.availableForSale">
                          <product-form>
                            <div class="alert mb-8 bg-error-bg text-error-text js-form-error text-start" role="alert" hidden></div>
                            <form method="post" action="/cart/add" accept-charset="UTF-8" class="js-product-form" enctype="multipart/form-data" novalidate="novalidate">
                              <input type="hidden" name="form_type" value="product">
                              <input type="hidden" name="utf8" value="✓">
                              <input type="hidden" name="id" :value="product.variants.nodes[0]?.id.split('gid://shopify/ProductVariant/')[1]">
                              <button  class="btn btn--primary w-full" data-add-to-cart-text="Add to cart" name="add" aria-haspopup="dialog">
                                  
                                  <span class="quick-add-btn-text">
                                    <svg width="16" height="16" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation">
                                      <path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z">
                                      </path>
                                    </svg>
                                    <span >
                                        Add to cart
                                      </span>
                                  </span>
                              </button>


                              <input type="hidden" name="product-id" :value="product?.id.split('gid://shopify/Product/')[1]">
                              <input type="hidden" name="properties[_personalizerai]" :value="product.attributionToken" />
                            </form>
                          
                          </product-form>
                          
                      </template>

                      <template x-if="product.variants.nodes.length > 1 && product.availableForSale">
                          <div class="no-js-hidden">
                            <button
                            x-effect="attributionTokenInitiator($el);"
                              data-personalizerai-attribution-token="${meta.attributionToken}"
    
                              type="button"
                              class="btn btn--primary w-full js-quick-add"
                              aria-haspopup="dialog"
                              :data-product-url="'/products/' + product.handle"
                              data-product-default-variant="false"
                              data-quick-add-listener-added="true"
                            >
                              <span class="quick-add-btn-icon block pointer-events-none">
                                <span class="visually-hidden">Choose Options</span>
                              </span>
                              <span class="quick-add-btn-text block pointer-events-none">
                                Choose Options</span
                              >
                            </button>
                            <a
                              :href="'/products/' + product.handle"
                              class="btn btn--secondary quick-add-view-btn"
                              >View details</a
                            >
                          </div>
                      </template>
                      
                </div>
        </div>
    </product-card>
    </li>


      
    
    `;
  }

  getProductCardState({ product, config, meta }) {
    let currentTranslations = meta.translations;
    const initialVariant = this._getInitialVariant(product);
    const stateId = `${meta.blockId}_${product.id}`
      .replaceAll("-", "_")
      .replaceAll(":", "_")
      .replaceAll("/", "_");

    const state = {
      shop: meta.shop || "",
      product,
      selectedVariantId: initialVariant?.id || null,
      config,
      selectedVariant() {
        let id = this.selectedVariantId;
        if (!id) return null;

        const variant = this.product.variants.nodes.find(
          (variant) => variant.id === id
        );
        if (!variant) return null;

        return variant;
      },

      getProductImageUrl() {
        let imageUrl = "";
        if (this.config.imageType === "featured") {
          imageUrl = this.product?.images?.nodes?.length
            ? this.product.images.nodes[0].url
            : "";
        } else if (this.config.imageType === "variant") {
          // @ts-ignore
          imageUrl = this.selectedVariant()?.image?.url || "";
        } else if (this.config.imageType === "featured-and-variant") {
          // @ts-ignore
          imageUrl = this.selectedVariant()?.image?.url || "";
        }

        // add placeholder image url
        return imageUrl ? imageUrl : "";
      },
      productPricing() {
        let priceRange = "";
        let compareAtPriceRange = "";

        if (this?.selectedVariant()?.price) {
          priceRange = meta.formatCurrency(this?.selectedVariant().price);
          compareAtPriceRange = this.selectedVariant().compareAtPrice
            ? meta.formatCurrency(this.selectedVariant()?.compareAtPrice)
            : "";
        } else {
          const minPrice = product.priceRange.minVariantPrice.amount;
          const maxPrice = product.priceRange.maxVariantPrice.amount;
          const minCompareAtPrice =
            product.compareAtPriceRange.minVariantPrice.amount;
          const maxCompareAtPrice =
            product.compareAtPriceRange.maxVariantPrice.amount;
          // TODO: fix the logic to show both price and compare at price when available
          if (!maxCompareAtPrice) {
            if (maxPrice === minPrice) {
              priceRange = meta.formatCurrency(
                product.priceRange.maxVariantPrice
              );
            } else {
              priceRange = `${meta.formatCurrency(
                product.priceRange.minVariantPrice
              )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;
            }
          } else if (maxCompareAtPrice > maxPrice) {
            if (
              maxPrice === minPrice ||
              maxCompareAtPrice === minCompareAtPrice
            ) {
              priceRange = meta.formatCurrency(
                product.priceRange.minVariantPrice
              );
              compareAtPriceRange = meta.formatCurrency(
                product.compareAtPriceRange.minVariantPrice
              );
            } else {
              priceRange = `${meta.formatCurrency(
                product.priceRange.minVariantPrice
              )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;

              compareAtPriceRange = `${meta.formatCurrency(
                product.compareAtPriceRange.minVariantPrice
              )}-${meta.formatCurrency(
                product.compareAtPriceRange.maxVariantPrice
              )}`;
            }
          } else {
            priceRange = `${meta.formatCurrency(
              product.priceRange.minVariantPrice
            )}-${meta.formatCurrency(product.priceRange.maxVariantPrice)}`;
          }
        }

        return { priceRange, compareAtPriceRange };
      },

      currentTranslations,
      addToCart: {
        loading: false,
        text: currentTranslations.addToCart,
        disabled: false,
      },
      async onAddToCart() {
        try {
          this.addToCart.loading = true;

          if (!this.selectedVariant()) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.unableToAdd;
            this.addToCart.disabled = true;
            setTimeout(() => {
              this.addToCart.text = currentTranslations.addToCart;
              this.addToCart.disabled = false;
            }, 2000);
            return;
          }

          const items = {
            items: [
              {
                id: this.selectedVariant().id.split(
                  "gid://shopify/ProductVariant/"
                )[1],
                quantity: 1,
                properties: {
                  _personalizerai:
                    this.product?.attributionToken ||
                    `model_id--${this.config.model}`,
                },
              },
            ],
          };

          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(items),
            }
          );

          if (response?.status && response?.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.outOfStock;
            this.addToCart.disabled = true;

            setTimeout(() => {
              this.addToCart.text = currentTranslations.outOfStock;
              this.addToCart.disabled = false;
            }, 2000);
            return;
          }

          this.addToCart.loading = false;
          this.addToCart.text = currentTranslations.added;
          this.addToCart.disabled = true;
          setTimeout(() => {
            this.addToCart.text = currentTranslations.addToCart;
            this.addToCart.disabled = false;
          }, 2000);
          return;
        } catch (err) {
          if (err?.status && err.status === 422) {
            this.addToCart.loading = false;
            this.addToCart.text = currentTranslations.outOfStock;
            this.addToCart.disabled = true;
          }
        } finally {
          this.addToCart.loading = false;
        }
      },
      formatCurrency: meta.formatCurrency,
    };

    return {
      id: stateId,
      state,
    };
  }

  _getInitialVariant(product) {
    const variantsAvailableForSale = product.variants.nodes.filter(
      (variant) => variant.availableForSale
    );

    if (variantsAvailableForSale.length <= 1) {
      return variantsAvailableForSale?.[0] || null;
    }

    const leastPriceVariant = variantsAvailableForSale.reduce(
      (acc, current) => {
        if (parseFloat(acc.price.amount) > parseFloat(current.price.amount)) {
          return current;
        } else {
          return acc;
        }
      },
      variantsAvailableForSale[0]
    );

    return leastPriceVariant;
  }
}
